<template>
  <div class="web_course_li" @click="goDetail(item)">
    <div class="whereWidth">
      <img
        class="web_course_img"
        :src="item.picPath ? item.picPath : path"
        alt=""
      />
    </div>
    <div style="height: 100px; background-color: #fff">
      <p class="best_courses_p">{{ item.title }}</p>
      <span class="web_course_pView">
        <!-- <p class="best_courses_p__p1">{{ item.videoSpeed }}</p> -->
        <div class="video_stats">
          <span class="stat_item">
            <img :src="view" alt="" class="pView_img" />
            <span>{{ item.viewCount || 0 }}</span>
          </span>
          <span class="stat_item">
            <img
              :src="like"
              alt=""
              class="pView_img"
              style="margin-left: 10px"
            />
            <span>{{ item.likeCount || 0 }}</span>
          </span>
        </div>
        <p class="best_courses_p__p2">
          {{ item.isVip === 1 ? "限会员免费" : "免费" }}
        </p>
      </span>
    </div>
  </div>
</template>
<script>
import { getIntegralUrl } from "@/api/moudles/home.js";
export default {
  name: "videoCard",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    toPath: {
      type: String,
      default: "videoplay",
    },
  },
  data() {
    return {
      path: require("@/assets/img/phoneIndex/phonebgc.png"),
      view: require("@/assets/img/videoLearn/view.png"),
      like: require("@/assets/img/videoLearn/isLike.png"),
    };
  },
  methods: {
    async goDetail(item) {
      const token = this.$store.state.user.token;
      localStorage.setItem("videoPlay", true);
      if (item.points > 0 && !token) {
        this.$message("请先登录后再查看！");
      } else if (item.points == 0) {
        // 是否会员
        if (item.isVip === 1) {
          // 登不登录都能看,有时间限制
          this.$router.push({
            name: this.toPath,
            params: {
              video_id: item.id,
              freeTime: item.freeTime,
              isVip: true,
            },
          });
        } else {
          // // 免费
          this.$router.push({
            name: this.toPath,
            params: {
              video_id: item.id,
              isVip: false,
            },
          });
        }
      } else {
        // 扣几分查看视频
        this.getIntergarUrl(item);
      }
    },
    async getIntergarUrl(item) {
      await getIntegralUrl({
        data: {
          type: "video",
          id: item.id,
        },
        success: (res) => {
          console.log("res", res);
          if (res.data) {
            if (item.isVip === 1) {
              // 登不登录都能看,有时间限制
              this.$router.push({
                name: this.toPath,
                params: {
                  video_id: item.id,
                  freeTime: item.freeTime,
                  isVip: true,
                },
              });
            } else {
              // // 免费
              this.$router.push({
                name: this.toPath,
                params: {
                  video_id: item.id,
                  isVip: false,
                },
              });
            }
          } else {
            this.$message(res.msg);
          }
        },
      });
    },
  },
};
</script>
<style scoped>
@media screen and (min-width: 750px) {
  .web_course_li {
    cursor: pointer;
    width: 280px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 4px 10px 4px rgb(0 0 0 / 6%);
    margin-bottom: 27px;
  }
  .whereWidth {
    width: 280px;
    height: 156px;
    overflow: hidden;
  }
  .web_course_img {
    width: 280px;
    height: 156px;
    transition: all 0.3s;
    object-fit: cover;
  }
}
@media screen and (max-width: 750px) {
  .web_course_li {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 4px 10px 4px rgb(0 0 0 / 6%);
    margin-bottom: 27px;
  }
  .whereWidth {
    width: 100%;
    height: 156px;
    overflow: hidden;
  }
  .web_course_img {
    width: 100%;
    height: 156px;
    transition: all 0.3s;
    object-fit: cover;
  }
}
.web_course_img:hover {
  transform: scale(1.1);
  cursor: pointer;
}
/* 精品课程 */
.best_courses_p {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 25px;
  font-weight: 400;
  padding: 7px 18px 0px;

  height: 52px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.best_courses_p__p1 {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
}

.best_courses_p__p2 {
  font-family: AlibabaPuHuiTi-Bold;
  font-size: 18px;
  color: #e02020;
  letter-spacing: 0;
  text-align: right;
  font-weight: 700;
}
.web_course_pView {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 18px 11px;
}
.web_course_pView__div {
  display: flex;
  align-items: center;
  padding: 4px;
  background-color: #eee;
  border-radius: 5px;
}

.video_stats {
  display: flex;
  align-items: center;
  gap: 12px;
}

.stat_item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #999999;
}

.stat_item i {
  font-size: 16px;
}

.pView_img {
  width: 20px;
  height: 20px;
}
</style>
